import { Helmet } from 'react-helmet-async';
import { ORIGIN } from '@/lib/i18nRoutes';
import { LEGAL_SEO } from '@/lib/legalSeo';

// SEO head for the Dutch-only legal routes (/agb/, /privacy/).
//
// These routes are NOT in TRANSLATED_ROUTES, so — unlike PageSEO — this head is
// language-INDEPENDENT: always a Dutch self-canonical + index robots + og/twitter,
// regardless of the in-app UI language. It mirrors exactly what build-shells.mjs
// bakes into the raw legal shell via seoHead(base, 'nl', …): canonical, robots,
// og:title/description/type/url/locale/image, and the full twitter card set.
//
// The bespoke Helmet these pages used before set only title/description/og/canonical
// — so on mount Helmet's data-rh reconciliation removed the baked robots + twitter
// tags (they weren't in the page's set), leaving the rendered legal page with no
// robots and no twitter metadata (Codex PR #5 finding 2). Emitting the full set here
// keeps raw == hydrated with exactly one of each.
export default function LegalSEO({ base }: { base: '/agb/' | '/privacy/' }) {
  const s = LEGAL_SEO[base];
  const url = ORIGIN + base;
  const ogImage = ORIGIN + s.image;
  return (
    <Helmet>
      <html lang="nl" />
      <title>{s.title}</title>
      <meta name="description" content={s.description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />

      <meta property="og:title" content={s.title} />
      <meta property="og:description" content={s.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="nl_NL" />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={s.title} />
      <meta name="twitter:description" content={s.description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
